module.exports = __webpack_public_path__ + "static/media/08.Sugreeva.cde676b9.JPG";